import { Database, FolderCog, Plug2, Settings2 } from "lucide-react";
import type { SettingsSection } from "../../../store/settings-store";
import type { ProductIconSlotId } from "../../../theme/registry/icon-slot-registry";

export const SECTION_LABELS: Record<SettingsSection, string> = {
    editor: "%editor.settings.section.editor%",
    runtime: "%editor.settings.section.runtime%",
    plugin: "%editor.settings.section.plugin%",
    sidecar: "%editor.settings.section.sidecar%",
};

export const SECTION_ICONS: Record<SettingsSection, React.ReactNode> = {
    editor: <Settings2 size={14} />,
    runtime: <FolderCog size={14} />,
    plugin: <Plug2 size={14} />,
    sidecar: <Database size={14} />,
};

export const SOURCE_LABELS = {
    default: "%editor.settings.source.default%",
    user: "%editor.settings.source.user%",
    workspace: "%editor.settings.source.workspace%",
    remoteHost: "%editor.settings.source.remoteHost%",
    env: "%editor.settings.source.env%",
    cli: "CLI",
} as const;

export const EFFECT_LABELS = {
    immediate: "%editor.settings.effect.immediate%",
    nextSession: "%editor.settings.effect.nextSession%",
    restart: "%editor.settings.effect.restart%",
} as const;

export const PRODUCT_ICON_PREVIEW_SLOTS: ProductIconSlotId[] = [
    "sidebar.explorer",
    "sidebar.extension",
    "sidebar.publish",
    "status.execution",
    "status.logs",
];
